var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('duration',_vm._b({attrs:{"value":_vm.durationValue,"title":_vm.formattedTimestamp}},'duration',_vm.durationOptions,false))}
var staticRenderFns = []

export { render, staticRenderFns }